export enum UserAttributeName {
    Title = 'title',
    FirstName = 'firstName',
    LastName = 'lastName',
    CompanyName = 'companyName',
    PhoneNumber = 'phoneNumber',
    Email = 'email'
}



// WEBPACK FOOTER //
// ./src/webportal/models/user/attribute.ts